<template>
  <v-card>
    <alert-error :error="error"></alert-error>

    <v-card-title>
      <span class="text-h5"
        >{{ $t('ITEM.EDIT') }} {{ $t('PERSONAL_INTERESTS.ITEM') }}</span
      >
    </v-card-title>

    <v-card-text>
      <v-form ref="form" v-model="valid" lazy-validation>
        <item-form v-model="tag" :languages="languages" />

        <v-container>
          <v-layout align-center justify-space-between row>
            <v-btn outlined text @click="$emit('cancel')">{{
              $t('BUTTON.CANCEL')
            }}</v-btn>
            <v-btn
              color="success"
              :disabled="!valid"
              :loading="loading"
              @click="validate"
            >
              {{ $t('BUTTON.UPDATE') }}
            </v-btn>
          </v-layout>
        </v-container>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'TagEditPage',

  components: {
    AlertError: () => import('@/modules/_global/_components/AlertError'),
    ItemForm: () => import('@/modules/tags/components/TagForm.vue')
  },

  props: {
    itemEdit: {
      type: Object,
      required: true
    },
    languages: {
      type: Array,
      required: true
    }
  },

  data: () => ({
    tag: null,
    error: null,
    valid: true
  }),

  computed: {
    loading() {
      return this.$store.getters['loading'];
    }
  },

  created() {
    this.tag = Object.assign({}, this.itemEdit);
  },

  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        let translations = [];

        this.languages.forEach(language => {
          if (this.tag[language.locale]) {
            translations.push({
              id: this.tag[language.locale + '_id'],
              language_id: language.id,
              name: this.tag[language.locale]
            });

            //delete this.tag[language.locale];
            //delete this.tag[language.locale + '_id'];
          }
        });

        this.tag.translations = translations;

        this.$store
          .dispatch('tag/update', this.tag)
          .then(({ data }) => {
            this.$store.commit('snackbar/setSnack', {
              status: 'success',
              text: this.$t('MESSAGE.SUCCESS')
            });
            this.$emit('success', data);
          })
          .catch(error => {
            this.error = error.response;
          });
      }
    }
  }
};
</script>
